// document.addEventListener("DOMContentLoaded", () => {
//   const headerWrapper = document.querySelector(".header-wrapper");
//   const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");

//   if (!headerWrapper) return;

//   headerWrapper.addEventListener("click", () => {
//     headerWrapper.classList.add("menu-active,color-scheme-1");
//   });

//   menuItems.forEach(item => {
//     const megaMenu = item.querySelector(".mega-menu__content");

//     if (!megaMenu) return;

//     // Show on hover
//     item.addEventListener("mouseenter", () => {
//       megaMenu.classList.add("mega-menu--open");
//       headerWrapper.classList.add("menu-active");
//     });

//     // Hide on out
//     item.addEventListener("mouseleave", () => {
//       megaMenu.classList.remove("mega-menu--open");
//       headerWrapper.classList.remove("menu-active");
//     });
//   });
// });
// document.addEventListener("click", function(e){

//   const nextBtn = e.target.closest(".slider-button--next");
//   const prevBtn = e.target.closest(".slider-button--prev");

//   if(!nextBtn && !prevBtn) return;

//   const slider = e.target.closest("media-gallery")?.querySelector(".quickadd-gallery");
//   if(!slider) return;

//   const slideWidth = slider.querySelector(".product__media-item")?.offsetWidth || 300;

//   if(nextBtn){
//     slider.scrollBy({
//       left: slideWidth,
//       behavior: "smooth"
//     });
//   }

//   if(prevBtn){
//     slider.scrollBy({
//       left: -slideWidth,
//       behavior: "smooth"
//     });
//   }

// });
// document.addEventListener('DOMContentLoaded', function () {
//   const smallBtn = document.querySelector('.grid-small');
//   const largeBtn = document.querySelector('.grid-large');

//   function changeGrid(cols, activeBtn) {
//     const productGrid = document.querySelector('#product-grid');

//     if (!productGrid) return;

//     // Remove existing desktop grid classes
//     productGrid.className = productGrid.className.replace(/grid--\d+-col-desktop/g, '');

//     // Add new grid class
//     productGrid.classList.add(`grid--${cols}-col-desktop`);

//     // Active state
//     smallBtn.classList.remove('active');
//     largeBtn.classList.remove('active');
//     activeBtn.classList.add('active');
//   }

//   if (smallBtn) {
//     smallBtn.addEventListener('click', function () {
//       changeGrid(3, this);
//     });
//   }

//   if (largeBtn) {
//     largeBtn.addEventListener('click', function () {
//       changeGrid(5, this);
//     });
//   }

//   // Default active state on page load
//   largeBtn?.classList.add('active');
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const textarea = document.getElementById("ContactForm-body");

//   if (!textarea) return;

//   const autoResize = () => {
//     if (textarea.value.trim() === "") {
//       textarea.style.height = "53px"; // reset when empty
//     } else {
//       textarea.style.height = "auto";
//       textarea.style.height = textarea.scrollHeight + "px";
//     }
//   };

//   // Run on load (important)
//   autoResize();

//   // Run on input
//   textarea.addEventListener("input", autoResize);
// });


// document.addEventListener('DOMContentLoaded', () => {
//   const stickyBar = document.getElementById('sticky-atc-bar');
//   const originalATC = document.querySelector('product-form button[type="submit"]');

//   if (!stickyBar || !originalATC) return;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.isIntersecting) {
//         stickyBar.classList.remove('active');
//       } else {
//         stickyBar.classList.add('active');
//       }
//     },
//     {
//       threshold: 0.1
//     }
//   );

//   observer.observe(originalATC);
// });
document.addEventListener('DOMContentLoaded', function () {

  const desktopSmall = document.querySelector('.grid-small');
  const desktopLarge = document.querySelector('.grid-large');

  const mobileSmall = document.querySelector('.grid-small-mobile');
  const mobileLarge = document.querySelector('.grid-large-mobile');

  function changeGrid(cols, activeButtons) {
    const productGrid = document.querySelector('#product-grid');

    if (!productGrid) return;

    // Remove existing classes
    productGrid.className = productGrid.className
      .replace(/grid--\d+-col-desktop/g, '')
      .replace(/grid--\d+-col-tablet-down/g, '');

    // Desktop
    if (window.innerWidth > 749) {
      productGrid.classList.add(`grid--${cols}-col-desktop`);
    }
    // Mobile
    else {
      productGrid.classList.add(`grid--${cols}-col-tablet-down`);
    }

    // Remove active class from all buttons
    [
      desktopSmall,
      desktopLarge,
      mobileSmall,
      mobileLarge
    ].forEach(btn => btn?.classList.remove('active'));

    // Add active class
    activeButtons.forEach(btn => btn?.classList.add('active'));
  }

  // Desktop
  desktopSmall?.addEventListener('click', function () {
    changeGrid(3, [desktopSmall]);
  });

  desktopLarge?.addEventListener('click', function () {
    changeGrid(5, [desktopLarge]);
  });

  // Mobile
  mobileSmall?.addEventListener('click', function () {
    changeGrid(1, [mobileSmall]); // 1 column mobile
  });

  mobileLarge?.addEventListener('click', function () {
    changeGrid(2, [mobileLarge]); // 2 columns mobile
  });

  // Default state
  if (window.innerWidth > 749) {
    desktopLarge?.classList.add('active');
  } else {
    mobileLarge?.classList.add('active');
  }

});